import React, { FC, RefObject } from 'react';
import { OrderPartsImg } from '@root/app/react/uikit';
import { OrderSelectBaseLayout } from '@component/OrderSelectBaseLayout';
import { useMediaDesktop } from '@app/react/common/useMedia';
import {
    OrderProductCategoryList,
    OrderProductCategoryListProps,
} from './OrderProductCategoryList';

interface IOrderCommonSelectComponentProps extends OrderProductCategoryListProps {
    rootRef?: RefObject;
    partsNameProps: string;
    showHelpBtn: boolean;
    onHelpClick: (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => void;
}

export const OrderCommonSelectComponent: FC<IOrderCommonSelectComponentProps> = (
    props,
) => {
    const {
        rootRef,
        categoryId,
        subCategoryId,
        categoryData,
        subCategoryData,
        categoryChange,
        subCategoryChange,
        selectedProduct,
        onSelectProduct,
        viewData,
        partsNameProps,
        showHelpBtn,
        onHelpClick,
    } = props;

    const isDesktop = useMediaDesktop();

    return (
        <OrderSelectBaseLayout
            header={isDesktop && (
                <OrderPartsImg
                    partsName={partsNameProps}
                    showHelpBtn={showHelpBtn}
                    onHelpClick={onHelpClick}
                />
            )}
            body={(
                <OrderProductCategoryList
                    rootRef={rootRef}
                    categoryId={categoryId}
                    subCategoryId={subCategoryId}
                    categoryData={categoryData}
                    subCategoryData={subCategoryData}
                    categoryChange={categoryChange}
                    subCategoryChange={subCategoryChange}
                    selectedProduct={selectedProduct}
                    onSelectProduct={onSelectProduct}
                    viewData={viewData}
                />
            )}
        />
    );
};
